import React from "react";

const FormContext = React.createContext({
    data: {},
    update: () => {},
});

export default FormContext
